const pxStudentRegistrants = {
  path: 'pxStudentRegistrants',
  props: true,
  component: resolve => require(['../../../../components/pages/student_user/pxStudentRegistrants'], resolve)
}
export default pxStudentRegistrants



// WEBPACK FOOTER //
// ./src/router/pages/student_user/pxStudentRegistrants/index.js